import PropTypes from 'prop-types';
import ContentfulParser from 'components/BlogCommon/Article/ContentfulParser';
import SectionTitle from 'UI/components/SectionTitle';
import Images from 'UI/components/Images';
import Illustration from 'UI/components/Illustration';
import Animated from 'UI/containers/Animated';
import { REVEAL_ANIMATION_PROPS } from 'utils/constants';
import dynamic from 'next/dynamic';
import { useImageSection } from './utils/useImageSection';
import styles from './styles.module.scss';

const VideoPlayer = dynamic(() => import('components/Common/VideoPlayer'));

const ImagesSection = (props) => {
  const {
    data,
    type,
    imagesUrl,
    text,
    sectionProps,
    sectionTitles,
  } = useImageSection(props);

  return (
    <section {...sectionProps}>
      {imagesUrl?.map(({ url, alt }) => (
        <Illustration
          transparent
          className={styles.bundleImage}
          src={url}
          alt={alt}
          key={`intro-images-bundles/${url}`}
        />
      ))}

      <SectionTitle {...sectionTitles} />

      <Images
        data={data}
        type={type}
        view={data.view}
        renderVideoPlayer={({ src, description }) => (
          <VideoPlayer
            src={src}
            description={description}
            withBlackout
            classes={{ container: styles.videoContainer, videoWrapper: styles.videoWrapper, description: styles.videoDescription }}
          />
        )}
      />

      {text && (
        <Animated
          {...REVEAL_ANIMATION_PROPS}
          transitionDelay={50}
        >
          <div className={styles.textContainer}>
            <ContentfulParser document={text} />
          </div>
        </Animated>
      )}
    </section>
  );
};

ImagesSection.prototype = {
  data: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.string.isRequired,
};

export default ImagesSection;
